import axios from "axios";

export const saveTemporaryObject = async (username, temporaryStorageVOToSave) => {
    try {
        const {data} = await axios.post("/api/temporaryStorage/create", {username, temporaryStorageVOToSave});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveTemporaryObject = async (username, key) => {
    try {
        const {data} = await axios.post("/api/temporaryStorage/view", {username, key});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
